import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { H2, H3, SmallOnly } from "commons";

import { Message } from "../../components/Message";
import { ValVsMimo, hasValidData } from "./ValVsMimo";
import { TransactionBreakdown } from "./TransactionBreakdown";
import { WARNING } from "../../helpers/ErrorHelpers";

export function AnalysisViewContent({ account, filteredAnalysis, rangeId, selectedAccounts }) {
    const scrollAnchor = useRef(null);

    useEffect(() => {
        if (scrollAnchor.current) {
            scrollAnchor.current?.scrollIntoView?.();
        }
    }, []);

    if (!hasValidData(filteredAnalysis, account)) {
        return (
            <Message
                severity={WARNING}
                text="No transactions have occurred within the selected date period. Please extend your date range."
                marginTop="40px"
            />
        );
    }

    const accountLabel = selectedAccounts?.[account]?.wrapperType
        ? `${selectedAccounts[account].wrapperType} ${account}`
        : account;
    const alias = selectedAccounts?.[account]?.alias;

    return (
        <Container>
            <SmallOnly>
                <div ref={scrollAnchor} data-testid="scroll-anchor" />
            </SmallOnly>
            <HeadingContainer>
                <H2>{account === "Combined" ? "Portfolio total" : accountLabel}</H2>
                {alias ? <H3 data-testid="account-alias">{alias}</H3> : null}
            </HeadingContainer>
            <ValVsMimo
                rangeId={rangeId}
                account={account}
                data={filteredAnalysis}
                selectedAccounts={selectedAccounts}
            />
            <TransactionBreakdown account={account} data={filteredAnalysis} rangeId={rangeId} />
        </Container>
    );
}

const Container = styled.div`
    margin-top: 1rem;
`;

const HeadingContainer = styled.div`
    margin-bottom: 2rem;
`;

AnalysisViewContent.propTypes = {
    account: PropTypes.string,
    filteredAnalysis: PropTypes.object,
    rangeId: PropTypes.string,
    selectedAccounts: PropTypes.object
};
